import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/journal/_manual-entry')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'manual-entry-list',
        label: 'Journals',
        to: '/clearing/finance/journal',
      }),
    }) satisfies AggregateBreadcrumb,
});
